import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";

/** 产品服务页 PV/UV 打点（失败静默） */
export async function recordProductPageVisit(
  spaceId: string,
  spaceProductId: string
): Promise<void> {
  const sid = spaceId.trim();
  const pid = spaceProductId.trim();
  if (!sid || !pid || useLongfansMock) {
    return;
  }
  await post<{ spaceId: string; spaceProductId: string }, boolean>(
    "/lark/app/space/recordProductPageVisit",
    { spaceId: sid, spaceProductId: pid },
    { silent: true }
  );
}
